// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Component } from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import PropTypes from "prop-types";

import { AppRoutes } from "components/AppRoutes";

const DEFAULT_FAILURE_COUNT = 3;
const MIN_DELAY_MS = 1000;
const MAX_DELAY_MS = 30000;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) =>
        !error.isNotFound && failureCount < DEFAULT_FAILURE_COUNT,
      retryDelay: (attemptIndex) =>
        Math.min(MIN_DELAY_MS * 2 ** attemptIndex, MAX_DELAY_MS),
    },
  },
});

class App extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
  };

  render() {
    const { store } = this.props;

    return (
      <Router>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <AppRoutes />
          </QueryClientProvider>
        </Provider>
      </Router>
    );
  }
}

export default App;
